import { IconButton, Table, TableCell } from '@mui/material';
import styled, { css } from 'styled-components';

export const TotalsContainer = styled.div`
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  padding: 24px;
  margin: 24px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #e9ecef;

  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 1180px) {
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    padding: 12px;
    margin: 12px 0;
    width: 100%;
    box-sizing: border-box;
  }

  @media (max-width: 480px) {
    padding: 8px;
    margin: 8px 0;
    gap: 4px;
  }
`;

export const TotalsValues = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 16px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  min-width: 150px;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  strong {
    font-size: 0.85rem;
    color: #6c757d;
    margin-bottom: 8px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  div {
    font-size: 1.1rem;
    font-weight: 700;
    color: var(--main-color);
    margin: 0;
  }

  @media (max-width: 1180px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    width: 100%;
    padding: 8px 12px;
    min-width: unset;
    box-sizing: border-box;

    strong {
      margin-bottom: 0;
      font-size: 0.7rem;
      white-space: nowrap;
    }

    div {
      font-size: 0.85rem;
      white-space: nowrap;
    }
  }

  @media (max-width: 480px) {
    padding: 6px 8px;

    strong {
      font-size: 0.65rem;
    }

    div {
      font-size: 0.75rem;
    }
  }
`;

export const RemoveContent = styled.div`
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-weight: 500;
  text-align: center;

  h3 {
    padding: 0;
    margin: 0 0 12px 0;
    font-size: 1.2rem;
    color: #dc3545;
    font-weight: 600;
  }

  p {
    color: #6c757d;
    margin: 0;
    line-height: 1.5;
  }
`;

export const TotalValue = styled.span`
  min-width: 120px;
  text-align: 'left';
`;

export const RemoveContentActions = styled.div`
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  gap: 12px;
  width: 100%;

  button {
    flex: 1;
    padding: 12px 24px;
    border-radius: 8px;
    font-weight: 600;
    text-transform: none;
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }
  }
`;

export const TableItems = styled(Table)`
  && {
    overflow: hidden;
    max-width: 100%;
    margin: 24px 0;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #e9ecef;
    .MuiTableHead-root {
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);

      th {
        font-weight: 600;
        color: #495057;
        font-size: 11px;
        text-transform: capitalize;
        letter-spacing: 0.3px;
        border-bottom: 2px solid #dee2e6;
        padding: 12px 8px;
        height: 40px;
      }
    }

    .MuiTableBody-root {
      tr {
        transition: background-color 0.2s ease;

        &:hover {
          background-color: #f8f9fa;
        }

        &:nth-of-type(even) {
          background-color: #fdfdfd;
        }
      }
    }

    @media (max-width: 1180px) {
      display: none;
    }
  }
`;

export const TableBodyCard = styled.div`
  padding: 12px;
  display: block;

  @media (min-width: 1180px) {
    margin-top: 16px;
    display: none;
  }
`;

export const TableCard = styled.div`
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e9ecef;
  padding: 16px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: linear-gradient(135deg, var(--main-color), #4a90e2);
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }

  & + & {
    margin: 16px 0;
  }
`;

export const HeaderCard = styled.div`
  border-radius: 8px 8px 0 0;
  padding: 12px 0;
  margin-bottom: 16px;
  border-bottom: 2px solid #e9ecef;

  display: flex;
  align-items: center;
  justify-content: space-between;

  .order {
    font-size: 16px;
    font-weight: 600;
    text-decoration: none;
    color: var(--main-color);
    margin-right: 10px;
    line-height: 16px;
    transition: color 0.2s ease;

    &:hover {
      color: #0056b3;
    }
  }

  .client-name {
    text-align: left;
    width: 410px;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #6c757d;
  }
`;

export const TableCardItem = styled.div`
  display: flex;
  justify-content: space-between;

  & + & {
    margin-top: 24px;
  }
`;

export const TableCardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  transition: background-color 0.2s ease;
  border-radius: 4px;

  &:hover {
    background-color: #f8f9fa;
    padding-left: 6px;
    padding-right: 6px;
  }

  & + & {
    margin-top: 8px;
    border-top: 1px solid #f0f0f0;
    padding-top: 12px;
  }
`;

interface ITableCellProps {
  statusid?: number;
}

export const TableCellCustom = styled(TableCell)<ITableCellProps>`
  && {
    height: 40px;
    font-size: 11px;
    padding: 8px 12px;
    border-bottom: 1px solid #f0f0f0;
    text-transform: capitalize;
    line-height: 1.3;

    strong {
      font-weight: 600;
    }

    .MuiTextField-root {
      .MuiInputBase-root {
        font-size: 11px;
        min-height: 32px;
      }
      .MuiInputLabel-root {
        font-size: 11px;
        transform: translate(14px, 8px) scale(1);
      }
      .MuiInputLabel-shrink {
        transform: translate(14px, -6px) scale(0.75);
      }
    }

    .MuiAutocomplete-root {
      .MuiInputBase-root {
        font-size: 11px;
        min-height: 32px;
        padding: 4px 8px;
      }
    }
  }
`;

export const TableCardTitle = styled.strong`
  font-size: 11px;
  font-weight: 600;
  color: #495057;
  margin-right: 12px;
  min-width: 100px;
  text-transform: capitalize;
  letter-spacing: 0.2px;
`;

export const TableCardDescription = styled.span<ITableCellProps>`
  text-align: right;
  font-size: 11px;
  font-weight: 500;
  color: #212529;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  padding: 2px 6px;
  border-radius: 4px;
  transition: all 0.2s ease;
  text-transform: capitalize;

  ${props =>
    props.statusid === 1 &&
    css`
      color: #fff !important;
      background: rgb(255, 200, 0);
      border: 1px solid rgb(255, 200, 0);
    `}

  ${props =>
    props.statusid === 2 &&
    css`
      color: #fff !important;
      background: #2e7d32;
      border: 1px solid #2e7d32;
    `}

  ${props =>
    props.statusid === 3 &&
    css`
      color: #fff !important;
      background: #d32f2f;
      border: 1px solid #d32f2f;
    `}

  ${props =>
    props.statusid &&
    props.statusid > 0 &&
    css`
      font-weight: 600 !important;
      min-width: 60px;
      max-width: 80px;
      text-align: center;
      justify-content: center;
      display: inline-flex;
      align-items: center;
      flex: none;
      margin-left: auto;
    `}
`;

export const TableCardActionsDescription = styled.span`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  padding: 2px 6px;
`;

export const IconButtonAdd = styled(IconButton)`
  background: linear-gradient(135deg, var(--main-color), #4a90e2);
  color: white !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #0056b3, #357abd);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  }

  svg {
    color: white;
    font-size: 2rem;
  }

  @media (min-width: 1180px) {
    && {
      display: none;
    }
  }

  @media (max-width: 1180px) {
    && {
      position: fixed;
      right: 16px;
      bottom: 80px;
      width: 56px;
      height: 56px;
      z-index: 1000;
    }
  }
`;

export const ButtonSaveContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin: 16px 20px 16px 0;

  button {
    color: white;
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    font-weight: 600;
    text-transform: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    }
  }

  @media (max-width: 1180px) {
    && {
      display: none;
    }
  }
`;

export const OrderItemListContainer = styled.div`
  position: relative;
  max-width: 100%;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 12px;
  margin: 16px 0;
  box-sizing: border-box;

  @media (max-width: 1580px) {
    overflow: auto;
  }

  @media (max-width: 1180px) {
    padding: 12px;
    margin: 12px 0;
  }

  @media (max-width: 480px) {
    padding: 8px;
    margin: 8px 0;
  }
`;

interface IDataInfoPropos {
  size?: number;
}

export const DataInfo = styled.div<IDataInfoPropos>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${props =>
    props.size && props.size > 0
      ? css`
          width: ${props.size}px;
        `
      : css`
          width: 50px;
        `}
`;

// Novos componentes para melhorar a interface
export const ActionButtonGroup = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;

  button {
    width: 30px;
    height: 30px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;

    svg {
      font-size: 16px;
    }

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      transform: none;
      background: #e0e0e0 !important;

      svg {
        color: #9e9e9e !important;
      }
    }
  }

  .edit-btn {
    background: #1976d2;
    color: white;

    &:hover:not(:disabled) {
      background: #1565c0;
    }
  }

  .delete-btn {
    background: #d32f2f;
    color: white;

    &:hover:not(:disabled) {
      background: #c62828;
    }
  }

  @media (max-width: 768px) {
    gap: 8px;

    button {
      width: 34px;
      height: 34px;

      svg {
        font-size: 18px;
      }
    }
  }
`;

export const StatusBadge = styled.span<{ statusId?: number }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: capitalize;
  letter-spacing: 0.3px;
  background: transparent;
  min-width: 60px;
  text-align: center;
  justify-content: center;

  ${props => {
    switch (props.statusId) {
      case 1:
        return css`
          color: #fff;
          background: rgb(255, 200, 0);
          border: 1px solid rgb(255, 200, 0);
        `;
      case 2:
        return css`
          color: #fff;
          background: #2e7d32;
          border: 1px solid #2e7d32;
        `;
      case 3:
        return css`
          color: #fff;
          background: #d32f2f;
          border: 1px solid #d32f2f;
        `;
    }
  }}
`;

export const PriceDisplay = styled.span`
  font-weight: 600;
  font-size: 11px;
  min-height: 20px;
`;

export const QuantityDisplay = styled.span`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: #f8f9fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 500;
  border: 1px solid #e9ecef;
  font-size: 11px;
  transition: all 0.2s ease;
  height: 20px;

  &:hover {
    border-color: #007bff;
    background: #f0f8ff;
    transform: translateY(-1px);
  }
`;

export const EditableFieldDisplay = styled.span`
  background: #f8f9fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 500;
  border: 1px solid #e9ecef;
  font-size: 11px;
  display: inline-block;
  min-width: 40px;
  text-align: center;
  transition: all 0.2s ease;
  min-height: 20px;
  align-items: center;
  display: flex;
  justify-content: center;

  &:hover {
    border-color: #007bff;
    background: #f0f8ff;
    transform: translateY(-1px);
  }
`;

export const ProductDisplay = styled.span`
  background: #f8f9fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 500;
  border: 1px solid #e9ecef;
  font-size: 11px;
  display: inline-block;
  min-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.2s ease;
  min-height: 20px;
  align-items: center;
  display: flex;

  &:hover {
    border-color: #007bff;
    background: #f0f8ff;
    transform: translateY(-1px);
  }
`;

export const ProductDescriptionDisplay = styled.span`
  font-weight: 500;
  font-size: 11px;
  display: inline-block;
  min-width: 200px;
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #212529;
  padding-top: 6px;
`;

export const DerivationDisplay = styled.span`
  background: #f8f9fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 500;
  border: 1px solid #e9ecef;
  font-size: 11px;
  display: inline-block;
  min-width: 50px;
  transition: all 0.2s ease;
  min-height: 20px;
  align-items: center;
  display: flex;

  &:hover {
    border-color: #007bff;
    background: #f0f8ff;
    transform: translateY(-1px);
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  color: #6c757d;

  svg {
    font-size: 4rem;
    margin-bottom: 16px;
    opacity: 0.5;
  }

  h3 {
    margin: 0 0 8px 0;
    font-size: 1.25rem;
    font-weight: 500;
  }

  p {
    margin: 0;
    font-size: 0.95rem;
    line-height: 1.5;
  }
`;
